export enum PaymentField {
    PAYMENT_URL = 'slipUrl',
    PAYMENT_AMOUNT = 'amount',
    PAYMENT_ID = 'docId',
}